<template>
  <div class='mask'>
    <div class='modal modal--new modal--small'>
      <div class="modal__close-container">
        <slot name="close-icon">
          <svg @click='$emit("close-modal")' class='modal__close-icon'>
            <use xlink:href='/images/svg-symbols.svg#close' />
          </svg>
        </slot>
      </div>

      <div class='modal__header'>
        <h1 class="modal__header__title">{{ title }}</h1>
      </div>

      <div class='modal__content'>
        <slot name='content'></slot>
      </div>

      <div class='modal__footer'>
        <slot name='footer'></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalBase',

  props: {
    title: {
      default: 'Atenção'
    }
  }
}
</script>
